/**
 * Flat sunny-yellow backdrop behind every menu. Previously this rendered a
 * blurred Three.js forest scene, which:
 *   • leaked the old level-1 environment through behind the lobby (visible
 *     as a "level flying over") even after intro and other 3D scenes had
 *     mounted on top;
 *   • cost GPU time we don't need on menu pages.
 *
 * A static CSS gradient is dramatically cheaper, never leaks geometry, and
 * matches the yellow-trim theme already used by the main menu chrome.
 */
export function MenuBackdrop() {
  return <div className="menu-backdrop menu-backdrop-yellow" aria-hidden />;
}
